import axios from "@/libs/api.request.js";

// 活动详情页
export const actInfo = (params) =>
  axios.request({
    url: `/box-active/bt-active/activities/${params.actId}`,
    params,
    method: "get",
  });

// 游戏详情页
export const gameInfo = (params) =>
  axios.request({
    url: `/box-game/bt-game/games/${params.appkey}`,
    params,
    method: "get",
  });

export const getEnv = () => {
  switch (process.env.VUE_APP_ENV) {
    case "dev":
      return "https://wxboxtest.hzwxbz999.cn";
    case "pre":
      return "https://wxboxpre.hzwxbz999.cn";
    default:
      return "https://wxbox.hzwxbz2.cn"; 
  }
}


// 活动详情页
export const wxActInfo = (params) =>
  axios.request({
    url: `${getEnv()}/wx-box-active/active/actives/${params.actId}`,
    method: "get",
  });

// 游戏详情页
export const wxGameInfo = (params) =>
  axios.request({
    url: `${getEnv()}/wx-box-game/game/detail`,
    params: {
      appkey: params.appkey
    },
    method: "get",
  });


// 游戏资讯列表
export const gameNews = (params) =>
axios.request({
  url: `${getEnv()}/wx-box-active/active/gameNews`,
  params,
  method: "get",
});

// 埋点上报
export const burnPoint = (data) =>
  axios.request({
  url: `${getEnv()}/wx-box-user/user/event-track`,
  data: {...data, wxos: 'h5'},
  method: "post",
});

// 分享详情
export const postShare = (data) =>
    axios.request({
        url: `${getEnv()}/wx-box-community/web/sharePostDetail`,
        data,
        method: "post",
    });

